import 'react-app-polyfill/ie11'
// import 'react-app-polyfill/stable' // This is causing issues with using cloud based styling on the Home Search Map using google maps - 7/10/2025
import { createRoot } from 'react-dom/client'

import { configApp } from './configApp'
import { AppContainer } from './App/AppContainer'

import './scss/main.scss'
import './scss/mapbox-overrides/index.scss'

const configPromise = configApp()

async function startApp() {
  await configPromise

  const container = document.getElementById('root')
  if (!container) {
    throw new Error('Root container not found')
  }
  const root = createRoot(container)

  root.render(<AppContainer />)
}

startApp()
